import { useDroppable } from '@dnd-kit/core';
import { Folder, FolderOpen, ChevronRight } from 'lucide-react';

export const DroppableFolder = ({ id, name, tierRequired, isActive, children, tabId, parentFolderName, subfolderCount }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `folder-${id}`,
    data: {
      type: 'folder',
      folderId: id,
      tabId: tabId
    }
  });

  return (
    <div 
      ref={setNodeRef}
      className={`glass-panel rounded-xl p-4 border flex justify-between items-center transition-all duration-200 ${
        isOver ? 'ring-2 ring-green-500 border-green-500 bg-green-500/10' : ''
      } ${isActive ? 'border-yellow-500/50' : 'border-border'}`}
      style={{ 
        borderColor: isOver ? '#22c55e' : isActive ? 'rgba(212, 175, 55, 0.5)' : 'rgba(212, 175, 55, 0.3)',
        transform: isOver ? 'scale(1.02)' : 'scale(1)'
      }}
    >
      <div className="flex items-center gap-3">
        {isOver ? (
          <FolderOpen size={24} style={{ color: '#22c55e' }} />
        ) : (
          <Folder size={24} style={{ color: '#D4AF37' }} />
        )}
        <div>
          <h4 className="font-bold flex items-center gap-1" style={{ color: isOver ? '#22c55e' : '#ffffff' }}>
            {parentFolderName && (
              <>
                <span className="text-xs font-normal" style={{ color: '#666' }}>{parentFolderName}</span>
                <ChevronRight size={12} style={{ color: '#666' }} />
              </>
            )}
            {name}
            {isOver && <span className="ml-2 text-sm font-normal">(Drop here)</span>}
          </h4>
          <div className="flex items-center gap-2">
            <p className="text-xs" style={{ color: '#a3a3a3' }}>
              Access: {tierRequired}
            </p>
            {subfolderCount > 0 && (
              <span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37' }}>
                {subfolderCount} subfolder{subfolderCount > 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default DroppableFolder;
